import { SVGProps } from "react";
/* eslint-disable prettier/prettier */
type Props = {
  size?: number;
  color?: string;
  className?: string;
} & SVGProps<SVGSVGElement>;
const SvgTesPin = ({ size, color, className, ...props }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <path
        d="M4.815 24c-1.24 0-2.431-.534-3.315-1.488l-.097-.107a5.145 5.145 0 0 1-1.038-1.67A5.524 5.524 0 0 1 0 18.756a6.032 6.032 0 0 1 .388-2.146A5.626 5.626 0 0 1 1.5 14.793L13.125 2.19C14.306.842 15.923.057 17.627.003c1.705-.054 3.36.628 4.61 1.9a6.653 6.653 0 0 1 1.313 2.156c.302.808.455 1.673.45 2.546a8.015 8.015 0 0 1-.537 2.836 7.465 7.465 0 0 1-1.488 2.392L11.527 23.178a.775.775 0 0 1-.243.232.691.691 0 0 1-.63.044.75.75 0 0 1-.268-.196.84.84 0 0 1-.17-.301.897.897 0 0 1 .064-.688.798.798 0 0 1 .22-.258l10.417-11.345c.495-.53.89-1.16 1.161-1.858a6.235 6.235 0 0 0 .422-2.203 5.35 5.35 0 0 0-.335-1.913 4.99 4.99 0 0 0-.985-1.622c-.97-.968-2.246-1.48-3.556-1.426-1.31.054-2.549.67-3.45 1.714L2.589 15.96a3.961 3.961 0 0 0-.8 1.278c-.187.48-.285.995-.288 1.517-.002.458.08.912.24 1.335a3.5 3.5 0 0 0 .69 1.131l.097.107c.672.678 1.558 1.039 2.47 1.007.912-.033 1.776-.456 2.405-1.18l10.013-10.85c.19-.21.338-.46.439-.734.1-.273.15-.567.146-.862a2.097 2.097 0 0 0-.132-.747 1.956 1.956 0 0 0-.386-.634 1.86 1.86 0 0 0-1.392-.563c-.514.02-1 .26-1.353.67l-6.9 7.497a.718.718 0 0 1-.53.24.719.719 0 0 1-.53-.244.865.865 0 0 1-.219-.582c.001-.218.08-.427.222-.58l6.93-7.523c.635-.713 1.5-1.124 2.41-1.144.91-.02 1.79.352 2.45 1.037.304.34.543.742.702 1.184.16.442.238.914.228 1.39a4.17 4.17 0 0 1-.276 1.489 3.883 3.883 0 0 1-.782 1.256L8.46 22.34C7.492 23.4 6.182 23.995 4.815 24Z"
        fill="currentColor"
      />
    </svg>
  );
};
SvgTesPin.defaultProps = {
  size: 16,
  color: "currentColor"
};
export default SvgTesPin;
